import { createFileRoute } from "@tanstack/react-router";



export const Route = createFileRoute("/_protected/class-sessions/$sessionId/student-stats")({
  head: () => ({
    meta: [{ title: "学员统计 · imiker CRM" }],
  })
});
